module.exports = __webpack_public_path__ + "static/media/gt.bc5b62b6.svg";